import { Upload } from "antd";
import { useState } from "react";
import styled from "styled-components";
import * as XLSX from "xlsx";

// Internal Imports
import { useForm } from "../../../contexts/form";
import { IListDetail } from "../../../interfaces/IListado";
import { GetListBaseDetailByID } from "../../../services/list";
import { COLORS } from "../../constants/colors";
import { getFile, tryCatch } from "../../constants/Utilities";
import { Mode } from "../../types/AllTypes";


interface Props {
    value: string;
    onChange: any;
    mode: Mode;
    hasLocalExcel: boolean;
}

const InputWrapper = styled.div<any>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: ${COLORS.white_color2(1)};
    border-radius: 5px;
    border: 1px solid ${COLORS.black_text_color3};
    height: 38px;
    padding-left: 8px;
    
     label {
        color: ${props => !!props.value ? COLORS.black_text_color1 : COLORS.black_text_color3};
        font-weight: 300;
        opacity: ${props => !!props.value ? 1 : 0.5};
        font-size: 1.05em;
    }

    .group-icon {
        position: relative;
        right: -1px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 38px;
        border-left: 1px solid ${COLORS.black_back_color5};
    }

    .icon-remove {
        background-color: ${COLORS.red_error2};
        height: 37px;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        color: white;
        width: 33px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .icon-remove:active {
        opacity: 0.7;
    }

   .icon-upload .ant-upload.ant-upload-select-picture-card, .icon-upload .ant-upload-list{
        background-color: ${COLORS.blue_active};
        height: 37px;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        width: 33px;
        border: none     
        
   }

   .icon-upload i {
       color: white;
   }


     .icon-download {
        background-color: white;
        height: 36px;
        color: ${COLORS.blue_active};
        width: 33px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .icon-download:active {
        opacity: 0.7;
    }

`;

const InputExcel = ({ value, onChange, mode, hasLocalExcel }: Props) => {

    // States
    const { listBaseForm, setLoadingExcel, downLoadExcelFromDTO, convertIListDetail } = useForm();

    // Error States
    const [errorsColumnCode, setErrorsColumnCode] = useState<string[]>();
    const [errorsColumnName, setErrorsColumnName] = useState<string[]>();
    const [errorsColumnLength, setErrorsColumnLength] = useState<string[]>();
    const [codigosDuplicados, setCodigosDuplicados] = useState<string[]>();
    const [ordenNoEntero, setOrdenNoEntero] = useState<string[]>();
    const [latEntero, setLatEntero] = useState<string[]>();
    const [lngEntero, setLngEntero] = useState<string[]>();

    // Methods
    const ValidateData = (sheet: any[]) => {
        let arrayColumnCode: string[] = [];
        let arrayColumnName: string[] = [];
        let arrayColumnLengh: string[] = [];
        let arraycodigoDuplicados: string[] = [];
        let arrayOrdenNoEntero: string[] = [];
        let arrayLatEntero: string[] = [];
        let arrayLngEntero: string[] = [];

        // Validacion de campos
        for (let index = 0; index < sheet.length; index++) {
            if (index === 0) continue;

            // Codigo no duplicados
            if (sheet.filter(x => x[0] === sheet[index][0]).length > 1) {
                if (!arraycodigoDuplicados.includes(sheet[index][0])) {
                    arraycodigoDuplicados.push(sheet[index][0]);
                }
            }

            // Minimo 8 columnas
            if (sheet[index].length < 8) {
                arrayColumnLengh.push((index + 1).toString())
            }

            // Columna Codigo Null
            if (sheet[index][0] == undefined || sheet[index][0].toString().trim() == '' || sheet[index][0].toString().toLowerCase() == 'null') {
                arrayColumnCode.push((index + 1).toString())
            }
            else if (sheet[index][0].toString().length > 100) {
                arrayColumnCode.push((index + 1).toString())
            }

            // Columna Nombre Null
            if (sheet[index][1] == undefined || sheet[index][1].toString().trim() == '' || sheet[index][1].toString().toLowerCase() == 'null') {
                arrayColumnName.push((index + 1).toString())
            }
            else if (sheet[index][1].toString().length > 500) {
                arrayColumnName.push((index + 1).toString())
            }

            // Columna 8 debe ser entero
            if (!/^([0-9])*$/.test(sheet[index][7])) {
                arrayOrdenNoEntero.push((index + 1).toString())
            }

            if (sheet[index][2] == undefined || sheet[index][2].toString().trim() == '' || sheet[index][2].toString().toLowerCase() == 'null') {
                sheet[index][2] = 0;
            } else {
                if (!/^\-?[0-9]+(.[0-9]+)?$/.test(sheet[index][2])) {
                    arrayLatEntero.push((index + 1).toString())
                }
            }

            if (sheet[index][3] == undefined || sheet[index][3].toString().trim() == '' || sheet[index][3].toString().toLowerCase() == 'null') {
                sheet[index][3] = 0;
            } else {
                if (!/^\-?[0-9]+(.[0-9]+)?$/.test(sheet[index][3])) {
                    arrayLngEntero.push((index + 1).toString())
                }
            }

            if (sheet[index][4] == undefined) {
                sheet[index][4] = "";
            }
            if (sheet[index][5] == undefined) {
                sheet[index][5] = "";
            }
            if (sheet[index][6] == undefined) {
                sheet[index][6] = "";
            }

        }

        setErrorsColumnCode(arrayColumnCode.length > 0 ? arrayColumnCode : undefined);
        setErrorsColumnName(arrayColumnName.length > 0 ? arrayColumnName : undefined);
        setErrorsColumnLength(arrayColumnLengh.length > 0 ? arrayColumnLengh : undefined);
        setCodigosDuplicados(arraycodigoDuplicados.length > 0 ? arraycodigoDuplicados : undefined);
        setOrdenNoEntero(arrayOrdenNoEntero.length > 0 ? arrayOrdenNoEntero : undefined);
        setLatEntero(arrayLatEntero.length > 0 ? arrayLatEntero : undefined);
        setLngEntero(arrayLngEntero.length > 0 ? arrayLngEntero : undefined);

        if (arrayColumnCode.length < 1 && arrayColumnName.length < 1 && arrayColumnLengh.length < 1 && arraycodigoDuplicados.length < 1 && arrayOrdenNoEntero.length < 1 && arrayLatEntero.length < 1 && arrayLngEntero.length < 1) {
            onChange(JSON.stringify(sheet));
        } else {
            setLoadingExcel(false);
        }
    }

    const getBase64 = (file: any) => {
        setLoadingExcel(true);
        setErrorsColumnCode(undefined);
        setErrorsColumnName(undefined);
        setErrorsColumnLength(undefined);
        setCodigosDuplicados(undefined);
        setOrdenNoEntero(undefined);
        setLatEntero(undefined);
        setLngEntero(undefined);
        const reader = new FileReader();

        tryCatch(() => {
            reader.onload = (e) => {
                let data = new Uint8Array((e.target?.result as any));
                let workbook = XLSX.read(data, { type: "array" });
                let worksheet = workbook.Sheets[workbook.SheetNames[0]];
                let sheet: any[] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
                ValidateData(sheet);
            }
            reader.readAsArrayBuffer(file);
        });
    };

    const downLoadExcelFromLocalOrDTO = () => {
        if (mode === 'Add' || !!hasLocalExcel) {
            setLoadingExcel(true);
            let data: any[] = JSON.parse(value);
            let response = (data as IListDetail[]);
            const resultList: any[] = [];
            let sheet: XLSX.WorkSheet;
            response.forEach((x) => {
                const detailMapped: any[] = [
                    x.codigo, x.nombre, x.latitud,
                    x.longitud, x.telefono1, x.telefono2,
                    x.telefono3, x.orden
                ];
                x.listadoDetalleAtributo?.forEach((y) => {
                    detailMapped.push(y.atributoValor);
                })
                resultList.push(detailMapped);
            });
            const resultMapped = convertIListDetail(response);
            sheet = XLSX.utils.json_to_sheet(resultMapped);;
            getFile(sheet);
            setLoadingExcel(false);
        } else {
            downLoadExcelFromDTO(listBaseForm!.listadoID);
        }
    }

    const removeFile = () => {
        onChange('');
    }

    return (
        <>
            <InputWrapper value={(!!value).toString()}>
                <label>{!!value || mode === 'Update' ? "Contiene archivo" : "Elegir archivo"}</label>
                <div className="group-icon">

                    {!!value || mode === 'Update'
                        ?
                        <nav className="icon-download" onClick={() => downLoadExcelFromLocalOrDTO()}><i className="fa-solid fa-download"></i></nav>
                        : <></>
                    }

                    {!!value && mode === 'Add'
                        ? <nav className="icon-remove" onClick={() => removeFile()}><i className="fa-solid fa-xmark"></i></nav>
                        : (
                            <nav>
                                <Upload
                                    listType="picture-card"
                                    fileList={[]}
                                    beforeUpload={getBase64}
                                    className="icon-upload"
                                >
                                    <i className="fa-solid fa-upload"></i>
                                </Upload>
                            </nav>
                        )

                    }
                </div>
            </InputWrapper>
            <div>
                {!!errorsColumnCode && (
                    <div className="errorFileWrapper">
                        <div className="errorFileTitle">Las siguientes filas no tienen código o excede los 100 caracteres</div>
                        {errorsColumnCode.map(value => (
                            <h3 key={value + "errorsColumnCode"} className="detailError">{value}</h3>
                        ))}
                    </div>
                )}

                {!!errorsColumnName && (
                    <div className="errorFileWrapper">
                        <div className="errorFileTitle">Las siguientes filas no tienen nombre o excede los 500 caracteres</div>
                        {errorsColumnName.map(value => (
                            <h3 key={value + "errorsColumnName"} className="detailError">{value}</h3>
                        ))}
                    </div>
                )}

                {!!errorsColumnLength && (
                    <div className="errorFileWrapper">
                        <div className="errorFileTitle">Las siguientes filas deben tener minimo 8 columnas</div>
                        {errorsColumnLength.map(value => (
                            <h3 key={value + "errorsColumnLength"} className="detailError">{value}</h3>
                        ))}
                    </div>
                )}


                {!!codigosDuplicados && (
                    <div className="errorFileWrapper">
                        <div className="errorFileTitle">Las siguientes codigos estan duplicados</div>
                        {codigosDuplicados.map(value => (
                            <h3 key={value + "codigosDuplicados"} className="detailError">{value}</h3>
                        ))}
                    </div>
                )}

                {!!ordenNoEntero && (
                    <div className="errorFileWrapper">
                        <div className="errorFileTitle">En las siguientes filas la colunma Orden debe ser numerica</div>
                        {ordenNoEntero.map(value => (
                            <h3 key={value + "ordenNoEntero"} className="detailError">{value}</h3>
                        ))}
                    </div>
                )}

                {!!latEntero && (
                    <div className="errorFileWrapper">
                        <div className="errorFileTitle">La latitud en las siguientes filas deben ser numericos</div>
                        {latEntero.map(value => (
                            <h3 key={value + "errorFileTitle"} className="detailError">{value}</h3>
                        ))}
                    </div>
                )}

                {!!lngEntero && (
                    <div className="errorFileWrapper">
                        <div className="errorFileTitle">La longitud en las siguientes filas deben ser numericos</div>
                        {lngEntero.map(value => (
                            <h3 key={value + "errorFileTitle"} className="detailError">{value}</h3>
                        ))}
                    </div>
                )}
            </div>

            {
                !!errorsColumnCode ||
                !!errorsColumnName ||
                !!errorsColumnLength ||
                !!codigosDuplicados ||
                !!ordenNoEntero ||
                !!latEntero ||
                !!lngEntero && <div style={{ marginBottom: '30px' }}></div>
            }      
        </>
    );
}

export default InputExcel;